import { getStore } from '../../../../data/configureStore';
import { updateOverrideViewpointCharacterId } from '../../../../data/slice';
import { cutsceneStepComplete } from '../stepComplete';

export function performViewpointStep(step) {
  getStore().dispatch(updateOverrideViewpointCharacterId({ characterId: step.characterId }));
  getStore().dispatch(cutsceneStepComplete());
}
